import { Reducer } from "../../../lib/redux";
import { extend } from "../../../utils/vanilla";
import { DriverSafetyActions } from "./actions";
import { DriverSafetyActionTypes, IDriverSafetyDataStore } from "./types";

export let defaultDriverSafetyData: IIdDictionary<IDriverSafetyDataStore[]> = {};

// Modeled after the driverChanges data store
export let driverSafety: Reducer<IIdDictionary<IDriverSafetyDataStore[]>, DriverSafetyActions> = (state = defaultDriverSafetyData, action) => {
    switch (action.type) {
        case DriverSafetyActionTypes.SET_DRIVER_SAFETY_INSIGHT: {
            if (action.payload.userId) {
                return {
                    ...state,
                    [action.payload.userId]: extend(true, [], action.payload.driverSafety)
                };
            }
            return state;
        }
        case DriverSafetyActionTypes.CLEAR_DRIVER_SAFETY_INSIGHT: {
            if (action.payload) {
                let newState = { ...state };
                delete newState[action.payload];
                return newState;
            }
            return defaultDriverSafetyData;
        }
        default:
            return state;
    }
};
